<template>
  <div class="design-preference">
    <div class="preference-main">
      <div class="preference-title">{{ $t('design.preference.designPreference') || '设计偏好' }}</div>
      <xl-tabs class="preference-tabs" v-model="typeActiveTab" :tabLists="typeTabList" @tab-click="handleTypeClick"
        :before-leave="leaveTypeTab">
        <template v-for="(type, index) in typeTabList" :key="type.name" class="type-tabs-content" #[type.name]>
          <!-- <div>{{ type.productTabList }}</div> -->
          <xl-tabs class="product-tabs" v-model="productActiveTab" :tabLists="type.productTabList" type="card"
            @tab-click="handleProductClick" :before-leave="leaveProductTab">
            <template v-for="(product, ind) in type.productTabList" :key="product.name" #[product.name]>
              <!-- <preference-product :ref="(el) => (productRef[ind] = el)"
                :selectProduct="productActiveTab"></preference-product> -->
            </template>
          </xl-tabs>
        </template>
      </xl-tabs>
      <preference-product  ref="productRef1"
      :selectProduct="productActiveTab" :selectType="typeActiveTab" :formConfigObj="formConfigObj" :currentType = 'currentType' :showScanningRod="showScanningRod" :showDashedBorder="showDashedBorder" :extraData="extraData" @getPreferenceList="productPreferenceList"></preference-product>
    </div>
  </div>
</template>

<script setup>
import { XlTabs, XlMessageBox, XlTabPane, XlImage } from '@shining3d/ui-components'
import { ref, onMounted, nextTick, watch, computed, h } from "vue";
import preferenceProduct from './components/preferenceProduct.vue'
import { useLang } from "@shining3d/common-module/utils/lang.js";
import { mockFData, mockCData, mockEData, mockBData, mockAData, mockDData, mockIData, mockKData } from '../../mock/preference.js';
import { cloneDeep, get } from 'lodash';
import { preferProductMap } from '../../common/enum.js'; 
import preferenceApi from '../../api/preference';
import { VueCookieNext } from "vue-cookie-next";
import _get from 'lodash/get';
import store from '@/store';
import { ElTabs } from '@shining3d/xl-element-plus';
import aiIcon from '../../assets/image/ai_icon.svg';

const { $t } = useLang("@shining3d/xl-design-order");
const lang = ref(VueCookieNext.getCookie("lang"));
const orgID = computed(() => _get( store, 'state.factorySelect.id', ''));
// const typeTabList = ref([
//   { label: $t('design.case.repair') || '修复', name: "repair", lazy: true },
//   { label: $t('design.case.implant') || '种植', name: "implant" },
//   { label: $t('design.case.orthodontic') || '正畸', name: "orthodontic", lazy: true },
//   { label: $t('design.case.removableDenture') || '活动义齿', name: "removableDenture", lazy: true },
// ]);
const typeTabList = ref([]);
// const typeTabList = ref([
//   {
//     label: $t('design.case.repair') || '修复',
//     name: "repair",
//     lazy: true,
//     productTabList: [
//       { label: $t('普通全冠') || '普通全冠', name: "prod_crown", data: mockAData, type: 'A', lazy: true },
//       { label: $t('内嵌体') || '内嵌体', name: "prod_inlay", data: mockAData, type: 'A', lazy: true },
//       { label: $t('高嵌体') || '高嵌体', name: "prod_onlay", data: mockAData, type: 'A', lazy: true },
//       { label: $t('内冠') || '内冠', name: "prod_coping", data: mockAData, type: 'A', lazy: true },
//       { label: $t('微笑设计') || '微笑设计', name: "prod_DSD", data: mockBData, type: 'B', lazy: true },
//       { label: $t('3D模型') || '3D模型', name: "prod_simple_3D_model", data: mockCData, type: 'C', lazy: true },
//     ]
//   },
//   {
//     label: $t('design.case.implant') || '种植',
//     name: "implant",
//     lazy: true,
//     productTabList: [
//       {
//         label: $t('种植全冠') || '种植全冠',
//         name: "prod_implant_crown",
//         lazy: true,
//         data: mockDData, type: 'D',
//       },
//       {
//         label: $t('种植内冠') || '种植内冠',
//         name: "prod_implant_coping",
//         lazy: true,
//         data: mockDData, type: 'D',
//       },
//       {
//         label: $t('3D种植模型') || '3D种植模型',
//         name: "prod_3D_implant_model",
//         data: mockEData,
//         type: 'D',
//         lazy: true
//       },
//       {
//         label: $t('个性化基台') || '个性化基台',
//         name: "prod_customized_implant_abutments",
//         data: mockFData,
//         lazy: true
//       },
//       {
//         label: $t('马泷桥') || '马泷桥',
//         name: "prod_malo_bridge",
//         lazy: true
//       },
//       {
//         label: $t('种植导板') || '种植导板',
//         name: "prod_guided_implant_surgery",
//         lazy: true
//       }
//     ]
//   },
//   {
//     label: $t('design.case.orthodontic') || '正畸',
//     name: "orthodontic",
//     lazy: true,
//     productTabList: [
//       {
//         label: $t('保持器') || '保持器',
//         name: "prod_splint",
//         lazy: true,
//         data: mockIData, type: 'I',
//       },
//       {
//         label: $t('夜磨牙垫') || '夜磨牙垫',
//         name: "prod_nightguard",
//         lazy: true,
//         data: mockIData, type: 'I',
//       }
//     ]
//   },
//   {
//     label: $t('design.case.removableDenture') || '活动义齿',
//     name: "removableDenture",
//     lazy: true,
//     productTabList: [
//       {
//         label: $t('全口活动义齿') || '全口活动义齿',
//         name: "prod_denture",
//         lazy: true,
//         data: mockKData, type: 'K',
//       },
//       {
//         label: $t('活动钢托') || '活动钢托',
//         name: "prod_partial_removable_denture",
//         lazy: true
//       }
//     ]
//   }
// ])
// 选中类型
const typeActiveTab = ref();
// 选中产品
const productActiveTab = ref('');
// 当前的产品类型
const currentType = ref('');
// 扫描杆是否展示
const showScanningRod = ref(false);
// 扫描杆组件上边框
const showDashedBorder = ref(false);
// 当前选中类型下的产品数据
const currentProduct = ({});
const productRef1 = ref();
const productRef = ref([])
// 参数数据
const formConfigObj = ref([]); 
// 额外数据
const extraData = ref('')
const tabChange = (productIndex, typeTab) => {
  // nextTick(() => {
    // const changValue = productRef.value?.[productIndex]?.changeParamsValue();
    const changValue = productRef1.value?.changeParamsValue();
    if (changValue) {
      const tabPromise = new Promise((resolve, reject) => {
        XlMessageBox({
          title: $t('design.confirmExit') || '确定退出',
          message: $t('design.orderDetail.exitAddTip') || '退出则不会保留当前数据',
          cancelButtonText: $t('design.cancel'),
          confirmButtonText: $t('design.confirm')
        }).then(() => {
          // todo跳转之前数据恢复为默认值
          resolve();
        }).catch(() => {
          return reject();
        });
      });
      return tabPromise;
    }
  // })
  // if (changValue) {
  //   XlMessageBox({
  //     title: $t('确定退出') || '确定退出',
  //     message: $t('退出则不会保留当前数据') || '退出则不会保留当前数据',
  //     cancelButtonText: $t('design.cancel'),
  //     confirmButtonText: $t('design.confirm')
  //   }).then(() => {
  //   });
  // }
}
// 类型tab切换
// const handleTypeClick = (tab) => {
//   // 产品tab默认选中每个类型的第一个产品
//   currentProduct.value = typeTabList?.find((item) => item?.name === tab.paneName) || {}
//   productActiveTab.value = currentProduct.value?.productTabList?.[0]?.name;
// }
// 产品tab切换前
const leaveProductTab = async (active, oldActive) => {
  if (active !== productActiveTab.value) {
    return await tabChange();
    // const productIndex = currentProduct.value?.productTabList?.findIndex(item => item?.name === productActiveTab.value)
    // const productIndex = currentProduct.value?.productTabList?.findIndex(item => item?.name === oldActive)
    // tabChange(productIndex)
    // return await tabChange(productIndex);
  }
}
// 类型产品切换前
const leaveTypeTab = async () => {
  return await tabChange();

  // 当时展示的产品的index
  // const productIndex = currentProduct.value?.productTabList?.findIndex(item => item?.name === productActiveTab.value)
  // const productIndex = currentProduct.value?.productTabList?.findIndex(item => item?.name === productActiveTab.value)

  // 产品tab默认选中每个类型的第一个产品
  // currentProduct.value = typeTabList?.find((item) => item?.name === activeName) || {}
  // productActiveTab.value = currentProduct.value?.productTabList?.[0]?.name;
  // return await tabChange(productIndex, 'typeTab');
}
// onMounted(() => {
//     currentProduct.value = typeTabList?.find((item) => item?.name === typeActiveTab.value) || {}
//     productActiveTab.value = currentProduct.value?.productTabList?.[0]?.name;
//   console.log( productActiveTab.value, 'productActiveTab.value====')

// })

// 获取设计偏好
const productPreferenceList = () => {
  preferenceApi.productPreferenceList({
    orgId: orgID.value,
    lang: lang.value
  }
  ).then((res) => {
    if( res && res.status ==='success' ){
      typeTabList.value = (res.result || []).map((type) => ({
        label: type?.productTypeName,
        name: type?.productType,
        lazy: true,
        productTabList: (type?.preference || []).map((product) => ({
          ...product,
          label: product?.productConfigName,
          name: product?.productConfig,
          labelComponent: product?.AiProduct ? h('div', { className: 'product-label-name' }, [ h('span', product?.productConfigName ), h( XlImage, { src: aiIcon })]) : '',
          lazy: true,
        }))
      }))
      typeActiveTab.value = typeActiveTab.value || typeTabList.value?.[0]?.name;
      // 提交保存后更新当前参数列表
      currentProduct.value = typeTabList.value?.find((item) => item?.name === typeActiveTab.value) || {}
      productActiveTab.value = productActiveTab.value || currentProduct.value?.productTabList?.[0]?.name;
      const current = currentProduct.value?.productTabList?.find((item) => item?.name === productActiveTab.value )
      formConfigObj.value = cloneDeep(current?.list) || [];
      extraData.value = cloneDeep(current?.extra) || '';
      productRef1.value?.forceUpdateForm();
    }
  })
}
productPreferenceList();

watch(() => typeActiveTab.value, () => {
  // nextTick(() => {
    currentProduct.value = typeTabList.value?.find((item) => item?.name === typeActiveTab.value) || {}
    productActiveTab.value = currentProduct.value?.productTabList?.[0]?.name;
    // currentType.value = currentProduct.value?.productTabList?.[0]?.type;
  // })
}, { immediate: true })
watch(()=>productActiveTab.value, () => {
  // nextTick(() => {
    const current = currentProduct.value?.productTabList?.find((item) => item?.name === productActiveTab.value )
    formConfigObj.value = cloneDeep(current?.list) || [];
    extraData.value = cloneDeep(current?.extra) || '';

    currentType.value = preferProductMap[current?.name]?.imageType;
    showScanningRod.value = preferProductMap[current?.name]?.showScanningRod || false;
    showDashedBorder.value = preferProductMap[current?.name]?.showDashedBorder || false;
    // currentProduct.value = productRef1.value?.getValue();
  // })

},{immediate: true} )

</script>

<style lang="scss" scoped>
.design-preference {
  font-family: 'Alibaba PuHuiTi 2.0';
  height: 100%;

  .preference-main {
    height: 95px;
    width: 100%;
    padding: 16px;
    margin-bottom: 16px;
    box-sizing: border-box;
    background: #FFFFFF;

    .preference-title {
      font-size: 18px;
      font-weight: 700;
      line-height: 25.2px;
      color: #2C364E;
      margin-bottom: 6px;
    }

    .product-tabs {
      :deep(.el-tabs__header) {
        border: 0 !important;

        .el-tabs__nav {
          box-sizing: border-box;
          border: 0 !important;
        }

        .el-tabs__item {
          height: 32px !important;
          line-height: 28px !important;
          box-sizing: border-box;
          padding: 0 19px;
          border: 2px solid #E0E4EA;
          margin-right: -2px;
          background: #FFFFFF;

          &:last-child {
            border-right: 2px solid #E0E4EA;
            border-radius: 0 4px 4px 0;
          }

          &:first-child {
            border-radius: 4px 0 0 4px;
          }
        }

        .el-tabs__item.is-active {
          border: 2px solid #5587FF !important;
          position: relative;
          z-index: 2;
        }
      }
      :deep(.el-tabs__item){
        position: relative;
        .iconfont{
          position: absolute;
          right: 0;
          top: 0;
        }
      }
    }
    .preference-tabs{
      min-height: 108px;
    }
  }

  :deep(.xl-tabs .el-tabs__nav-wrap) {
    padding-left: 0 !important;
  }

  :deep(.xl-tabs .el-tabs__content) {
    padding: 0 !important;
  }
  .removable-denture{
    height: calc( 100vh - 210px );
    background: #FFFFFF;
  }
}
:deep(.product-label-name){
  display: flex;
  align-items: center;
  .el-image{
    display: flex;
    align-items: center;  
    margin-left: 8px;
  }
}
</style>